<template>
  <path id="Path_806" data-name="Path 806" d="M8.006,20a2,2,0,0,0,2-2h-4a2,2,0,0,0,2,2" />
  <path
    id="Path_807"
    data-name="Path 807"
    d="M9,2.079V.98a.98.98,0,1,0-1.959,0v1.1A7.005,7.005,0,0,0,1.006,9v4.589l-.231.226a1.863,1.863,0,0,0-.667,2.1,1.849,1.849,0,0,0,1.908,1.036h11.99a1.845,1.845,0,0,0,1.907-1.033,1.859,1.859,0,0,0-.665-2.1l-.242-.237V9A7.005,7.005,0,0,0,9,2.079M2.474,14.951l.532-.52V9a5,5,0,1,1,10,0v5.421l.542.531Z"/>
</template>
